import { PipeTransform } from '@angular/core';
var VisualizacionImagesPipe = /** @class */ (function () {
    function VisualizacionImagesPipe() {
        this.assetsBasePath = 'assets/images/';
    }
    VisualizacionImagesPipe.prototype.transform = function (text) {
        switch (text) {
            case 'A':
                return this.assetsBasePath + 'header-illustration.png';
            case 'B':
                return this.assetsBasePath + 'header-illustration-camion.png';
            case 'C':
                return this.assetsBasePath + 'header-acoplado.png';
            case 'D':
                return this.assetsBasePath + 'header-tractor.png';
            case 'E':
                return this.assetsBasePath + 'header-moto.png';
            case 'F':
                return this.assetsBasePath + 'header-minibus.png';
            case 'G':
                return this.assetsBasePath + 'header-casa-rodante.png';
            default:
                return '';
        }
    };
    return VisualizacionImagesPipe;
}());
export { VisualizacionImagesPipe };
